import React from 'react';

import ReactDOM from 'react-dom';

export interface Props {
  app: string;
  name: string;
}

const Portal: React.FC<React.PropsWithChildren<Props>> = ({ app, name, children }) => {
  const querySelector = `[data-react-portal='${app}.${name}']`;
  const element = document.querySelector(querySelector);

  if (element) {
    return ReactDOM.createPortal(children, element);
  }
  return null;
};

export default Portal;
